import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import NavBar from '@components/common/NavBar'

import services from '@services'
import presenters from '@presenters'
import coordinators from '@coordinators'
import { HandleError } from '@coordinators/composed'

const mapStateToProps = (state) => {
  const { id, lastLoggedInHq, locale, firstName, email } = state.user
  const {
    headquarter: { userHeadquarters },
  } = state

  return {
    lastLoggedInHq,
    locale,
    userId: id,
    userName: firstName,
    userEmail: email,
    headquarters: userHeadquarters,
  }
}

const mapDispatchToProps = () => {
  const {
    CoreService,
    HeadquarterService,
    RestService,
    RouterService,
    SessionService,
    UIService,
  } = services
  const { pResponseGeneric, pResponseHeadquarters, pResponseUser } =
    presenters.Api

  const changeHeadquarter = coordinators.ChangeHeadquarter({
    CoreService,
    HeadquarterService,
    RestService,
    RouterService,
    SessionService,
    UIService,
    pResponseHeadquarters,
    pResponseUser,
    HandleError,
  })
  const loadHeadquarters = coordinators.LoadUserHeadquarters({
    HeadquarterService,
    RestService,
    pResponseHeadquarters: pResponseGeneric,
    HandleError,
  })
  const setSessionLocation = coordinators.SetSessionLocation({ SessionService })
  const loadAllHeadquarters = coordinators.LoadHeadquarters({
    HeadquarterService,
    RestService,
    pResponseHeadquarters: pResponseGeneric,
    HandleError,
  })
  const signOut = coordinators.SignOut({
    CoreService,
    RestService,
    RouterService,
    HandleError,
  })

  return {
    changeHeadquarter,
    loadHeadquarters,
    setSessionLocation,
    loadAllHeadquarters,
    signOut,
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBar))
